
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30111',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30111",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54280",
  "head-dlb": "static-1.4938",
  "hs-test-utils": "static-1.7920",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11366",
  "I18n": "static-7.1604",
  "quartz": "static-1.6882",
  "quartz-config": "static-1.660",
  "quartz-core": "static-1.6101",
  "react-dlb": "static-1.77",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.771",
  "enviro": "static-4.428",
  "feedback-shared-ui": "static-1.54267",
  "feedback-utils": "static-1.54271",
  "forms-embed-utils-lib": "static-1.4370",
  "forms-utils-lib": "static-1.12408",
  "foundations-assets": "static-1.4759",
  "foundations-components": "static-1.7744",
  "foundations-theming": "static-1.4322",
  "hub-http": "static-1.6127",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11674",
  "icons": "static-2.639",
  "immutable": "static-2.77",
  "quick-fetch": "static-1.3842",
  "raven": "static-3.5829",
  "react": "static-7.184",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16565",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5274",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.485",
  "tinymce-plugins": "static-1.57214",
  "transmute": "static-2.85",
  "ui-images": "static-2.1131",
  "UIComponents": "static-3.8313",
  "hs-promise-rejection-tracking": "static-1.5489",
  "PortalIdParser": "static-2.388",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9542",
  "styled-components": "static-2.88",
  "bend-plugin-trellis-migration": "static-1.3333",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3159",
  "quartz-webpack": "static-1.3106",
  "foundations-theming-specialty": "static-1.2038",
  "property-description-translator": "static-1.3760",
  "HeadJS": "static-2.736",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3031",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4232",
  "jasmine-runner": "static-1.6376",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.820",
  "hubspotter-http": "static-1.4578",
  "mobile-manifest-mixins": "static-1.509",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.557",
  "quartz-head": "static-1.547",
  "quartz-i18n": "static-1.557",
  "quartz-routing": "static-1.312",
  "quartz-test": "static-1.557",
  "quartz-tracking": "static-1.261",
  "ui-fonts": "static-1.628",
  "usage-tracker-container": "static-1.7234",
  "usage-tracker-core": "static-1.7094",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.154",
  "conversations-skeleton-state": "static-1.7159",
  "reference-resolvers": "static-1.8076",
  "sanitize-text": "static-1.8053",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10282",
  "sanitize": "static-1.4381",
  "outpost": "static-1.4102",
  "rpc-client-utils": "static-1.4552",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4013",
  "floating-ui": "static-1.54",
  "hs-story-utils": "static-1.9338",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1559",
  "bend-plugin-foundations-theming": "static-1.2805",
  "foundations-theming-base": "static-1.3307",
  "stylex": "static-1.30",
  "csstype": "static-1.50",
  "ai-components-ui-library": "static-1.8704",
  "atom": "static-1.4979",
  "codemirror": "static-5.93",
  "content-assistance-lib": "static-1.7618",
  "ContentUtils": "static-1.68072",
  "data-token-picker": "static-1.16243",
  "file-manager-components": "static-1.23328",
  "FileManagerCore": "static-1.38827",
  "FileManagerLib": "static-1.38968",
  "frontend-preferences-client": "static-1.7832",
  "hub-http-contrib": "static-1.2951",
  "interframe": "static-3.4671",
  "layout-dnd-components": "static-1.12267",
  "layout-dnd-utils": "static-1.11242",
  "property-translator": "static-1.5315",
  "react-codemirror": "static-1.10532",
  "react-colorpicker": "static-2.10117",
  "reference-resolvers-lite": "static-1.7999",
  "rich-text-lib": "static-1.19672",
  "tinymce-data": "static-1.40185",
  "tinymce-themes": "static-1.56070",
  "ui-addon-emoji-picker": "static-1.9795",
  "ui-addon-sales-email": "static-1.5120",
  "ui-brand-identity-lib": "static-1.14831",
  "bender-build-tools": "static-1.3063",
  "hub-http-shared-msw-handlers": "static-1.9749",
  "hubspotter-http-shared-msw-handlers": "static-1.9747",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "usage-tracker-session-replay": "static-1.4930",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "chirp-fetch": "static-1.1789",
  "chatspot-core": "static-1.20853",
  "copilot-toolkit": "static-1.10867",
  "data-fetching-client": "static-1.9583",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4677",
  "ui-addon-video-player": "static-1.8605",
  "ui-coaching-tips": "static-1.28279",
  "usage-tracker": "static-1.7244",
  "cms-field-types": "static-1.4718",
  "content-icons-ui": "static-1.2204",
  "integrations-lib": "static-1.15813",
  "customer-data-objects": "static-1.7568",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4559",
  "apollo-stack-hubspot": "static-3.84",
  "graphql": "static-1.80",
  "immer": "static-1.33",
  "immerable": "static-1.4061",
  "ui-addon-iframeable": "static-1.8958",
  "video-components-external": "static-1.10974",
  "video-data-lib": "static-1.34632",
  "audio-components": "static-1.5780",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29125",
  "FileManagerImages": "static-1.36479",
  "foundations-components-legacy": "static-1.769",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.523",
  "ui-universal-auth": "static-1.8849",
  "urlinator": "static-1.4440",
  "video-components": "static-1.12977",
  "video-embed": "static-1.35466",
  "ts-schema": "static-1.4004",
  "ContentData": "static-1.68147",
  "layout-data-lib": "static-1.9567",
  "react-dnd-compat": "static-1.4527",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1461",
  "external-options-client-types": "static-1.4084",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6783",
  "hs-promise-utils": "static-1.5502",
  "inbound-db-properties-service-client": "static-1.3772",
  "NamespacedHubStyle": "static-2.8993",
  "growth-onboarding-confetti": "static-1.2979",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11057",
  "amplitude-session-replay-browser": "static-1.58",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5503",
  "magpie-types": "static-1.4963",
  "simple-logging-lib": "static-1.2960",
  "growth-onboarding-feedback-components": "static-1.6490",
  "flux-actions": "static-1.325",
  "hubspot-apollo-client": "static-1.4786",
  "integrations-error-boundary-lib": "static-1.13228",
  "integrations-tracking-lib": "static-1.5505",
  "laboratory-lib": "static-3.7067",
  "native-integrations-shared-strings": "static-1.7694",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10056",
  "unified-auth": "static-1.363",
  "navigation-messaging": "static-1.7007",
  "content-media-composition-data-lib": "static-1.11954",
  "content-media-compositions": "static-2.15961",
  "idb-keyval": "static-1.42",
  "media-bridge-lib": "static-1.18764",
  "unified-auth-core-lib": "static-1.644",
  "social-insights-client-types": "static-1.21817",
  "advanced-menus-core": "static-1.14987",
  "advanced-menus-lib": "static-1.11948",
  "ExportDialog": "static-6.10298",
  "ui-memberships-settings-lib": "static-1.33784",
  "conditional-properties-service-client": "static-1.3723",
  "crm-pipelines-api-client-types": "static-1.4068",
  "framework-builder-read-service-client": "static-1.3935",
  "framework-data-schema-quick-fetch": "static-1.6688",
  "inbound-db-meta-service-client": "static-1.3516",
  "multi-currency-client-types": "static-1.3617",
  "persist-promise": "static-1.3618",
  "foundations-components-test-utils": "static-1.5227",
  "reactive-lib": "static-1.632",
  "hubspot-apollo-cache": "static-1.245",
  "universal-page-editor-lib": "static-1.2917",
  "microsoft-drive-integration-lib": "static-1.46",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3643",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14986",
  "simple-menus-lib": "static-1.16503",
  "crm-record-cards-service-types": "static-1.3536",
  "location-customization-utils-lib": "static-1.8946",
  "react-flip-move": "static-1.68"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30111",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54280",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-test-utils": "/hs-test-utils/static-1.7920",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11366",
  "I18n": "/I18n/static-7.1604",
  "quartz": "/quartz/static-1.6882",
  "quartz-config": "/quartz-config/static-1.660",
  "quartz-core": "/quartz-core/static-1.6101",
  "react-dlb": "/react-dlb/static-1.77",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.771",
  "enviro": "/enviro/static-4.428",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54267",
  "feedback-utils": "/feedback-utils/static-1.54271",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4370",
  "forms-utils-lib": "/forms-utils-lib/static-1.12408",
  "foundations-assets": "/foundations-assets/static-1.4759",
  "foundations-components": "/foundations-components/static-1.7744",
  "foundations-theming": "/foundations-theming/static-1.4322",
  "hub-http": "/hub-http/static-1.6127",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11674",
  "icons": "/icons/static-2.639",
  "immutable": "/immutable/static-2.77",
  "quick-fetch": "/quick-fetch/static-1.3842",
  "raven": "/raven/static-3.5829",
  "react": "/react/static-7.184",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16565",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5274",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tinymce-plugins": "/tinymce-plugins/static-1.57214",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1131",
  "UIComponents": "/UIComponents/static-3.8313",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9542",
  "styled-components": "/styled-components/static-2.88",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3333",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3159",
  "quartz-webpack": "/quartz-webpack/static-1.3106",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2038",
  "property-description-translator": "/property-description-translator/static-1.3760",
  "HeadJS": "/HeadJS/static-2.736",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3031",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4232",
  "jasmine-runner": "/jasmine-runner/static-1.6376",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.820",
  "hubspotter-http": "/hubspotter-http/static-1.4578",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.509",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.557",
  "quartz-head": "/quartz-head/static-1.547",
  "quartz-i18n": "/quartz-i18n/static-1.557",
  "quartz-routing": "/quartz-routing/static-1.312",
  "quartz-test": "/quartz-test/static-1.557",
  "quartz-tracking": "/quartz-tracking/static-1.261",
  "ui-fonts": "/ui-fonts/static-1.628",
  "usage-tracker-container": "/usage-tracker-container/static-1.7234",
  "usage-tracker-core": "/usage-tracker-core/static-1.7094",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.154",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7159",
  "reference-resolvers": "/reference-resolvers/static-1.8076",
  "sanitize-text": "/sanitize-text/static-1.8053",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10282",
  "sanitize": "/sanitize/static-1.4381",
  "outpost": "/outpost/static-1.4102",
  "rpc-client-utils": "/rpc-client-utils/static-1.4552",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4013",
  "floating-ui": "/floating-ui/static-1.54",
  "hs-story-utils": "/hs-story-utils/static-1.9338",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1559",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2805",
  "foundations-theming-base": "/foundations-theming-base/static-1.3307",
  "stylex": "/stylex/static-1.30",
  "csstype": "/csstype/static-1.50",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8704",
  "atom": "/atom/static-1.4979",
  "codemirror": "/codemirror/static-5.93",
  "content-assistance-lib": "/content-assistance-lib/static-1.7618",
  "ContentUtils": "/ContentUtils/static-1.68072",
  "data-token-picker": "/data-token-picker/static-1.16243",
  "file-manager-components": "/file-manager-components/static-1.23328",
  "FileManagerCore": "/FileManagerCore/static-1.38827",
  "FileManagerLib": "/FileManagerLib/static-1.38968",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7832",
  "hub-http-contrib": "/hub-http-contrib/static-1.2951",
  "interframe": "/interframe/static-3.4671",
  "layout-dnd-components": "/layout-dnd-components/static-1.12267",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11242",
  "property-translator": "/property-translator/static-1.5315",
  "react-codemirror": "/react-codemirror/static-1.10532",
  "react-colorpicker": "/react-colorpicker/static-2.10117",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7999",
  "rich-text-lib": "/rich-text-lib/static-1.19672",
  "tinymce-data": "/tinymce-data/static-1.40185",
  "tinymce-themes": "/tinymce-themes/static-1.56070",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9795",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5120",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14831",
  "bender-build-tools": "/bender-build-tools/static-1.3063",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9749",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9747",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4930",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "chirp-fetch": "/chirp-fetch/static-1.1789",
  "chatspot-core": "/chatspot-core/static-1.20853",
  "copilot-toolkit": "/copilot-toolkit/static-1.10867",
  "data-fetching-client": "/data-fetching-client/static-1.9583",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4677",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8605",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28279",
  "usage-tracker": "/usage-tracker/static-1.7244",
  "cms-field-types": "/cms-field-types/static-1.4718",
  "content-icons-ui": "/content-icons-ui/static-1.2204",
  "integrations-lib": "/integrations-lib/static-1.15813",
  "customer-data-objects": "/customer-data-objects/static-1.7568",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4559",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "graphql": "/graphql/static-1.80",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4061",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8958",
  "video-components-external": "/video-components-external/static-1.10974",
  "video-data-lib": "/video-data-lib/static-1.34632",
  "audio-components": "/audio-components/static-1.5780",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29125",
  "FileManagerImages": "/FileManagerImages/static-1.36479",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.769",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.523",
  "ui-universal-auth": "/ui-universal-auth/static-1.8849",
  "urlinator": "/urlinator/static-1.4440",
  "video-components": "/video-components/static-1.12977",
  "video-embed": "/video-embed/static-1.35466",
  "ts-schema": "/ts-schema/static-1.4004",
  "ContentData": "/ContentData/static-1.68147",
  "layout-data-lib": "/layout-data-lib/static-1.9567",
  "react-dnd-compat": "/react-dnd-compat/static-1.4527",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1461",
  "external-options-client-types": "/external-options-client-types/static-1.4084",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6783",
  "hs-promise-utils": "/hs-promise-utils/static-1.5502",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3772",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8993",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2979",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11057",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5503",
  "magpie-types": "/magpie-types/static-1.4963",
  "simple-logging-lib": "/simple-logging-lib/static-1.2960",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6490",
  "flux-actions": "/flux-actions/static-1.325",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4786",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13228",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5505",
  "laboratory-lib": "/laboratory-lib/static-3.7067",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7694",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10056",
  "unified-auth": "/unified-auth/static-1.363",
  "navigation-messaging": "/navigation-messaging/static-1.7007",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11954",
  "content-media-compositions": "/content-media-compositions/static-2.15961",
  "idb-keyval": "/idb-keyval/static-1.42",
  "media-bridge-lib": "/media-bridge-lib/static-1.18764",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.644",
  "social-insights-client-types": "/social-insights-client-types/static-1.21817",
  "advanced-menus-core": "/advanced-menus-core/static-1.14987",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11948",
  "ExportDialog": "/ExportDialog/static-6.10298",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33784",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3723",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4068",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3935",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6688",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3516",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3617",
  "persist-promise": "/persist-promise/static-1.3618",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5227",
  "reactive-lib": "/reactive-lib/static-1.632",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.245",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2917",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.46",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3643",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14986",
  "simple-menus-lib": "/simple-menus-lib/static-1.16503",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3536",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8946",
  "react-flip-move": "/react-flip-move/static-1.68"
}
};
